//! @ngInject
export function payerSetupModalCtrl($scope, $rootScope, $uibModalInstance, $state, fields, data, DatabaseApi, toaster, FormService, hhaxIntegrationService) {
    const init = () => {
        if (data.id) {
            setPhoneAndFax(data, 'remove');
            initHHAXPocMappingButton();
        }

        // This modal renders its own action row so that "Save & close" and the POC mapping button
        // share a line; the one built into form-fields.html would sit on its own line above them.
        $scope.hideSaveFormButton = true;
        $scope.fields = FormService.getFields(fields, data, $scope.viewModeOnly);
        $scope.form = {};
    }

    // The POC mapping screen only applies to payers that report to HHAeXchange, and it is gated
    // by the same permission as its endpoints.
    const initHHAXPocMappingButton = () => {
        $scope.canOpenHHAXPocMapping = false;

        if (!$rootScope.isPermittedByKey("view_evv_duty_code_mapping")) {
            return;
        }

        hhaxIntegrationService.getHHAXIntegrationPayers().then(res => {
            $scope.canOpenHHAXPocMapping = res.payers.includes(data.id);
        });
    }

    $scope.openHHAXPocMapping = () => {
        $uibModalInstance.dismiss();
        $state.go("app.payerHhaxPocMapping", { payerId: data.id });
    }

    $scope.submitForm = function () {
        // The save button lives outside the form now, so nothing marks the form as submitted on
        // our behalf; without this the invalid-field highlighting never appears.
        if ($scope.form.data.$setSubmitted) {
            $scope.form.data.$setSubmitted();
        }

        if ($scope.form.data.$invalid) {
            return;
        }

        var newData = FormService.prepareFormData($scope.fields);
        newData.zipCode = newData.zipCode.toString();
        newData.addressComponents = null;
        setPhoneAndFax(newData, 'add');

        if (data.id) {
            DatabaseApi.put('agencies/' + $rootScope.agencyId + '/agency_members/' + $rootScope.agencyMemberId + '/payers/' + data.id, newData) //{[field.name]: field.value})
                .then(function (res) {
                    console.log(res);
                    toaster.pop('success', "Payer saved");
                    $scope.closeModal();
                }, function (err) {
                    toaster.pop('error', "Something went wrong", "Could not change Payer settings")
                });
        } else {
            DatabaseApi.post('agencies/' + $rootScope.agencyId + '/agency_members/' + $rootScope.agencyMemberId + '/payers', newData).then(function (res) {
                console.log(res);
                toaster.pop('success', "Payer saved");
                $scope.closeModal();
            }, function (err) {
                toaster.pop('error', "Something went wrong", "could not add Payer");
            });
        }
    };

    $scope.fieldChanged = function(item){
        if(item.type.type === "Boolean" && data.id){
            $scope.submitForm();
        }
    }

    $scope.closeModal = function () {
        $uibModalInstance.close('ok');
    };

    $scope.exit = function () {
        $uibModalInstance.dismiss();
    };

    function setPhoneAndFax(data, action) {
        var phonePrefix = new RegExp("^[+]1", "i");
        switch (action) {
            case 'add': {
                if(data.phone  && !phonePrefix.test(data.phone)) {
                    data.phone = "+1" + data.phone;
                }
                if(data.fax && !phonePrefix.test(data.fax)) {
                    data.fax = "+1" + data.fax;
                }
                break
            }

            case 'remove': {
                if(data.phone !== null && phonePrefix.test(data.phone)) {
                    data.phone = data.phone.substr(2);
                }
                if(data.fax !== null && phonePrefix.test(data.fax)) {
                    data.fax = data.fax.substr(2);
                }
                break
            }
            default: {
                break;
            }
        }
    }

    init();
};
